export default __webpack_public_path__ + "static/media/Faisal.9eb2fbb3.png";